import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { DecoIconComponent } from '../deco-icon/deco-icon.component';

@Component({
    selector: 'message',
    standalone: true,
    imports: [MessagesModule, ToastModule, TranslateModule, DecoIconComponent],
    templateUrl: './message.component.html',
    styleUrl: './message.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageComponent {
    id = input.required<string>();

    text = input<string[] | null>(null);
    severity = input<'warn' | 'error' | 'info' | 'success' | 'secondary'>('warn');
    closable = input<boolean>(false);
    icon = input<string | null>(null);
    enableService = input<boolean>(true);
}
